import { Icon } from "@mui/material";
import MDButton from "components/MDButton";

export default function EmployeesTableData() {
  const formEmployeeRows = (data, editEmployee) => {
    const result = [];
    for (const dt of data) {
      result.push({
        name: dt.name,
        code: dt.code,
        status: dt.is_active ? "Active" : "Inactive",
        action: (
          <MDButton
            variant="outlined"
            color="info"
            iconOnly
            onClick={() => {
              editEmployee(dt);
            }}
          >
            <Icon>edit</Icon>
          </MDButton>
        ),
      });
    }
    return result;
  };

  return {
    formEmployeeRows,
    employeeHeaders: [
      { Header: "Name", accessor: "name", align: "center" },
      { Header: "Employee Code", accessor: "code", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Action", accessor: "action", align: "center" },
    ],
  };
}
